(function () {
  'use strict';

  const API = 'https://millennial-receipt-app.vercel.app/api/wishlist';
  const customerId = window.MILLENNIAL_CUSTOMER_ID;

  let wishlistItems = [];

  // ==============================
  // 初期化
  // ==============================
  async function init() {
    try {
      const res = await fetch(`${API}?customerId=${customerId}`);
      const data = await res.json();
      wishlistItems = data.items || [];
      updateAllButtons();
      renderWishlistPage();
    } catch (e) {
      console.error('[Wishlist] init error:', e);
    }
  }

  // ==============================
  // ボタン表示を全て同期
  // ==============================
  function updateAllButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach((btn) => {
      const productId = String(btn.dataset.productId);
      const isActive = wishlistItems.includes(productId);
      btn.classList.toggle('wishlist-btn--active', isActive);
      btn.setAttribute('aria-label', isActive ? 'お気に入りから削除' : 'お気に入りに追加');
    });
  }

  // ==============================
  // 追加/削除トグル
  // ==============================
  async function toggle(productId) {
    const isAdded = wishlistItems.includes(productId);

    try {
      const res = await fetch(API, {
        method: isAdded ? 'DELETE' : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customerId, productId }),
      });
      const data = await res.json();
      wishlistItems = data.items;
      updateAllButtons();
      showToast(isAdded ? 'お気に入りから削除しました' : 'お気に入りに追加しました ♡');
    } catch (e) {
      console.error('[Wishlist] toggle error:', e);
    }
  }

  // ==============================
  // お気に入りページを描画
  // ==============================
  async function renderWishlistPage() {
    const container = document.getElementById('wishlist-products');
    if (!container) return;

    if (wishlistItems.length === 0) {
      container.innerHTML = '<p class="wishlist-empty">お気に入りに追加した商品がありません</p>';
      return;
    }

    // バックエンド API 経由で商品情報を取得（Storefront トークン不要）
    try {
      const res = await fetch(`${API}?customerId=${customerId}`);
      const data = await res.json();
      const products = data.products || [];
      container.innerHTML = products.length
        ? products.map(renderProductCard).join('')
        : '<p class="wishlist-empty">お気に入りに追加した商品がありません</p>';
    } catch (e) {
      console.error('[Wishlist] page render error:', e);
    }
  }

  function renderProductCard(product) {
    const numericId = product.id;
    const priceText = product.price ? `¥${Number(product.price).toLocaleString()}` : '';
    const imgUrl = product.image || '';
    const imgAlt = product.title;

    return `
      <div class="wishlist-card">
        <a href="/products/${product.handle}" class="wishlist-card__img-link">
          ${imgUrl ? `<img src="${imgUrl}" alt="${imgAlt}" class="wishlist-card__img" loading="lazy">` : ''}
        </a>
        <div class="wishlist-card__body">
          <a href="/products/${product.handle}" class="wishlist-card__title">${product.title}</a>
          <p class="wishlist-card__price">${priceText}</p>
          <div class="wishlist-card__actions">
            <a href="/products/${product.handle}" class="wishlist-card__btn-cart">商品を見る</a>
            <button
              class="wishlist-btn wishlist-btn--active"
              data-wishlist-btn
              data-product-id="${numericId}"
              aria-label="お気に入りから削除"
              type="button"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    `;
  }

  // ==============================
  // トースト通知
  // ==============================
  function showToast(message) {
    let toast = document.getElementById('wishlist-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'wishlist-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('wishlist-toast--show');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => toast.classList.remove('wishlist-toast--show'), 2500);
  }

  // ==============================
  // クリックイベント（委任）
  // ==============================
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();

    // 未ログインはログインページへ
    if (!customerId) {
      window.location.href = btn.dataset.loginUrl || '/account/login';
      return;
    }

    const productId = String(btn.dataset.productId);
    if (productId) toggle(productId);
  });

  init();
})();
